// extracted by mini-css-extract-plugin
export default {"container":"wc9Y5","text":"USAV-","clamp":"Q4M-9"};